import React from "react";
import {
  ZoomIn,
  ZoomOut,
  RotateCw,
  Search,
  Columns2,
  Maximize2,
  ChevronUp,
  ChevronDown,
  Printer,
} from "lucide-react";

export type FitMode = "none" | "width" | "page";

interface ViewerToolbarProps {
  currentPage: number;
  totalPages: number;
  zoom: number; // 1 = 100%
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFit: (mode: FitMode) => void;
  onRotate: () => void;
  onGoToPage: (page: number) => void;
  onToggleSearch: () => void;
  onToggleThumbnails: () => void;
  onPrint: () => void;
  printing?: boolean;
}

const ViewerToolbar: React.FC<ViewerToolbarProps> = ({
  currentPage,
  totalPages,
  zoom,
  onZoomIn,
  onZoomOut,
  onFit,
  onRotate,
  onGoToPage,
  onToggleSearch,
  onToggleThumbnails,
  onPrint,
  printing,
}) => {
  return (
    <div className="viewer-toolbar">
      <div className="viewer-toolbar-group">
        <button
          className="viewer-btn"
          title="Toggle thumbnails"
          onClick={onToggleThumbnails}
        >
          <Columns2 size={18} />
        </button>
      </div>

      <div className="viewer-toolbar-group viewer-page-nav">
        <button
          className="viewer-btn"
          title="Previous page"
          disabled={currentPage <= 1}
          onClick={() => onGoToPage(currentPage - 1)}
        >
          <ChevronUp size={18} />
        </button>
        <input
          className="viewer-page-input"
          type="number"
          min={1}
          max={totalPages}
          value={currentPage}
          onChange={(e) => {
            const v = Number(e.target.value);
            if (v >= 1 && v <= totalPages) onGoToPage(v);
          }}
        />
        <span className="viewer-page-total">/ {totalPages}</span>
        <button
          className="viewer-btn"
          title="Next page"
          disabled={currentPage >= totalPages}
          onClick={() => onGoToPage(currentPage + 1)}
        >
          <ChevronDown size={18} />
        </button>
      </div>

      <div className="viewer-toolbar-group viewer-zoom">
        <button className="viewer-btn" title="Zoom out (Ctrl -)" onClick={onZoomOut}>
          <ZoomOut size={18} />
        </button>
        <span className="viewer-zoom-label">{Math.round(zoom * 100)}%</span>
        <button className="viewer-btn" title="Zoom in (Ctrl +)" onClick={onZoomIn}>
          <ZoomIn size={18} />
        </button>
        <button className="viewer-btn viewer-btn-text" title="Fit width" onClick={() => onFit("width")}>
          <Maximize2 size={16} />
          <span>Width</span>
        </button>
        <button className="viewer-btn viewer-btn-text" title="Fit page" onClick={() => onFit("page")}>
          Page
        </button>
      </div>

      <div className="viewer-toolbar-group viewer-toolbar-right">
        <button className="viewer-btn" title="Rotate view" onClick={onRotate}>
          <RotateCw size={18} />
        </button>
        <button className="viewer-btn" title="Find (Ctrl F)" onClick={onToggleSearch}>
          <Search size={18} />
        </button>
        <button
          className="viewer-btn"
          title="Print (Ctrl P)"
          onClick={onPrint}
          disabled={printing}
        >
          <Printer size={18} />
        </button>
      </div>
    </div>
  );
};

export default ViewerToolbar;
